export default __webpack_public_path__ + "de934bed711ca0a1755b66e08f26b34f.png";